export default {
  showSnackbar: (
    text: string,
    type: 'error' | 'warning' | 'info' | 'success',
    keepOpen: boolean = false
  ) => {
    return
  },
  close: () => {
    return
  },
  setKeepOpen: (keepOpen: boolean) => {
    return
  }
}



// WEBPACK FOOTER //
// ./src/services/snackbars.ts